import { Container } from "typedi";
import { CONTRACT_ADDRESS } from "../../constants/tokens";
import { BurnService } from "../../services";

export class TokenBurnService {
  public fetchTokenBurns = async (params) => {
    try {
      let burnService = Container.get(BurnService);
      const { token, dateRange, querySize, maxResults } = params;
      if (!dateRange[0]._isAMomentObject || !dateRange[1]._isAMomentObject)
        throw new Error("Date range not valid!");

      const { fromTimestamp, toTimestamp, limit, max, orderBy } = {
        fromTimestamp: dateRange[0].format("x"),
        toTimestamp: dateRange[1].format("x"),
        limit: querySize,
        max: maxResults,
        orderBy: "block_timestamp,desc",
      };

      const [burns, count] = await burnService.getBurns(
        CONTRACT_ADDRESS[token]!,
        fromTimestamp,
        toTimestamp,
        limit,
        max,
        orderBy
      );

      return {
        data: burns,
        total: count,
      };
    } catch (e) {
      console.log(e);
      throw new Error("Error connecting to transaction service");
    }
  };
}
